import { render, staticRenderFns } from "./baseSetting.vue?vue&type=template&id=deee67ee&scoped=true"
import script from "./baseSetting.vue?vue&type=script&lang=js"
export * from "./baseSetting.vue?vue&type=script&lang=js"
import style0 from "./baseSetting.vue?vue&type=style&index=0&id=deee67ee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deee67ee",
  null
  
)

export default component.exports